var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("x-grid", {
            ref: "grid",
            attrs: {
              id: "formList",
              rowId: _vm.rowId,
              url: _vm.url,
              columns: _vm.columns,
              "form-config": _vm.formConfig,
              "toolbar-config": _vm.toolbarConfig,
              "print-config": _vm.printConfig,
              "pager-config": _vm.pagerConfig,
              "checkbox-config": _vm.checkboxConfig,
              "export-config": _vm.exportConfig,
              cellClick: _vm.chooseRow,
              cellDbClick: _vm.updateRow,
            },
            scopedSlots: _vm._u([
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "vxe-button",
                      {
                        staticStyle: { "margin-right": "10px" },
                        attrs: { size: "mini", status: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.updateRow({ row: row })
                          },
                        },
                      },
                      [_vm._v("查看详情")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "formModal",
        {
          attrs: {
            title: "意向大客户详情",
            centered: "",
            footer: null,
            maskClosable: false,
            visible: _vm.editModalVisible,
            width: 1200,
            closable: true,
          },
          on: { cancelled: _vm.closeDetailPop },
        },
        [
          _vm.editModalVisible
            ? _c("detailForm", {
                ref: "detailForm",
                attrs: { rowId: _vm.editRowId },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }